import { useTranslation } from 'react-i18next';

import { Body1, Caption, Stack } from '@myphx-engineering/phx-design-system';
import { constants } from '@myphx-engineering/phx-design-system/framework';

import type { PricingInfo } from '../../../util/config/get-pricing';
import MedicationPricing from '../order-details/MedicationPricing';

export const SwitchToCashDetails = ({
    pricingInfo,
}: {
    pricingInfo: PricingInfo;
}) => {
    const { t } = useTranslation();

    return (
        <Stack gap="sm">
            <Body1>{t('switchPage.toCashDescription.line1')}</Body1>
            <Body1 bold>{t('switchPage.toCashDescription.line2')}</Body1>
            <Body1 bold>{t('switchPage.toCashDescription.line3')}</Body1>
            <Body1 bold>
                {t('switchPage.toCashDescription.line4', {
                    reg: constants.unicode.REGISTERED,
                })}
            </Body1>
            <MedicationPricing pricingInfo={pricingInfo} />
            <Caption>
                {t('switchPage.toCashDescription.disclaimer', {
                    reg: constants.unicode.REGISTERED,
                })}
            </Caption>
        </Stack>
    );
};
